// @ts-nocheck

import isEmpty from 'lodash/isEmpty';
const tokenName = 'user';

type TokenManager = {
  getToken: () => string | null;
  setToken: (newToken: string) => void;
  clearToken: () => void;
};

export const tokenManager = (): TokenManager => {
  // Токен авторизации
  let token: string | null;
  // Получение токена из мемоизированной переменной или localStorage
  const getToken = (): string | null =>
    (isEmpty(token) ? '' : token) || localStorage.getItem(tokenName) || null;

  return {
    // Получение токена
    getToken,
    // Обновление токена
    setToken: (newToken: string): void => {
      if (newToken) {
        localStorage.setItem(tokenName, newToken);
        token = newToken;
      }
    },
    clearToken: () => {
      token = null;
      localStorage.removeItem(tokenName);
    }
  };
};

const tokenWrapper = tokenManager();

export default tokenWrapper;
